import { render, staticRenderFns } from "./PdfModalShow.vue?vue&type=template&id=37888492&scoped=true&"
import script from "./PdfModalShow.vue?vue&type=script&lang=js&"
export * from "./PdfModalShow.vue?vue&type=script&lang=js&"
import style0 from "./PdfModalShow.vue?vue&type=style&index=0&id=37888492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37888492",
  null
  
)

export default component.exports